export default {
  labels: {
    invoice: 'Invoice',
    on_site: 'Pay on site (Cash/Card)',
  },
};
